import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import "./Faq.scss";

export default function Faq({ data, customData }) {
  const { title, description, faqs} = !customData ? data : customData;
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleExpandContent = (index) => {
    if (index === expandedIndex) {
      setExpandedIndex(null);
    } else {
      setExpandedIndex(index);
    }
  };

  return (
    <div className="faq-wrapper">
      <Container>
        <div className="faq-container">
          <h2>{title}</h2>
          <p>{description}</p>
          <div className="faq-card-container">
            <ul>
              {faqs.map((item, index) => {
                return (
                  <Fragment key={(`faq${index}`)}>
                    <FaqItem 
                      title={item.title} 
                      expand={() => handleExpandContent(index)} 
                      isSelected={expandedIndex === index} />
                    { expandedIndex === index && <li className="description-container">
                      <div className="description-content">
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                      </div>
                    </li>}
                  </Fragment>);
              })}
            </ul>
          </div>
        </div>
      </Container>
    </div>
  );
}

export function FaqItem({ title, expand, isSelected }) {
  return (
    <li className={"faq-card"}>
      <button 
        type="button" 
        className={isSelected ? "buttonSelectedStyles" : "buttonStyles"} 
        onClick={() => expand()}>{title}</button>
    </li>
  );
}

Faq.propTypes = {
  data: PropTypes.object.isRequired,
  customData: PropTypes.object,
};

FaqItem.propTypes = {
  title: PropTypes.string.isRequired,
  expand: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
};
